export const workerMessages = {
  FILE_CALCULATE_UPLOAD: 'file:calculate_upload',
  FILE_CALCULATE_UPLOAD_PROGRESS: 'file:calculate_upload:progress',
  FILE_CALCULATE_UPLOAD_DONE: 'file:calculate_upload:done',
  // FLAG:useDocuAi — checksum calculation failed (FileReader error: file moved/locked/permission
  // change between the drop and the read). Before this existed the worker rejected a promise
  // nobody held and posted nothing back, so the file sat in `calculating` forever and its batch
  // could never settle.
  FILE_CALCULATE_UPLOAD_ERROR: 'file:calculate_upload:error',
}
